import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';

const ButtonLink = ({ to, className = '', children }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleClick = (e) => {
        e.preventDefault();
        if (loading) return;

        setLoading(true);
        setTimeout(() => {
            navigate(to)
            setLoading(false);
        }, 2000);
    };

    return (
        <LoadingButton
            onClick={handleClick}
            loading={loading}
            variant="contained"
            sx={{
                paddingX: 3,
                paddingY: 1.5,
                backgroundColor: '#000000', // Black
                '&:hover': {
                    backgroundColor: '#1a1a1a', // Slightly lighter black for hover
                },
                color: '#ffffff',
                textTransform: 'none',
                borderRadius: '16px',
                boxShadow: 'none',
                '&:hover:before': {
                    boxShadow: 'none',
                },
            }}
        >
            {children}
        </LoadingButton>
    );
};

export default ButtonLink;
